import React from 'react';
import { Footer as RFooter } from 'rsuite';

const Footer = () => {
  return <RFooter style={{ textAlign: 'center', fontSize: 12, padding: 5 }}>© 2022, DISH Network L.L.C. All rights reserved.</RFooter>;
};

export default Footer;
